import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Modal,
    Button
} from '@gpstrackit/gtc-react-controls';

import {
    Alert,
    Typography
} from '@mui/material';

import { NotificationManager } from 'Components/Notifications';

//actions
import {
    reset,
    closeDeleteModal,
    deleteDriverStatusLogs
} from './redux/slice';
import { DEFAULT_DRIVER_STATUS_ACTIONS } from '../../constants';

export const defaultDriverStatusActions = {
    "-2": "settingsDriverStatus_clockIn",
    "-1": "settingsDriverStatus_clockOut",
    "-3": "settingsDriverStatus_meakbegin",
    "-4": "settingsDriverStatus_meakEnd",
}

const DeleteDriverStatusLog = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { refresh } = props;

    const open = useSelector(state => state.driverStatusLogDeleteRedux.open);
    const response = useSelector(state => state.driverStatusLogDeleteRedux.response);
    const loading = useSelector(state => state.driverStatusLogDeleteRedux.loading);
    const driverStatusLogs = useSelector(state => state.driverStatusLogDeleteRedux.driverStatusLogs);
    const error = useSelector(state => state.driverStatusLogDeleteRedux.error);

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (open && response) {
            NotificationManager.warning(
                messages['driverStatusLogDelete_successMessage'],
                messages['driverStatusLogDelete_success'],
                3000,
                null,
                null,
                'success',
                null
            );

            if (refresh) refresh();
            handleClose();
        }
    }, [open, response]);

    useEffect(() => {
        if (open && error) {
            setErrorMessage(error?.message || messages['errorMessage']);
            dispatch(reset({ error: false, response: null }));
        }
    }, [error, open]);

    const handleClose = useCallback(() => {
        setErrorMessage("");
        dispatch(closeDeleteModal());
        dispatch(reset());
    });

    return (
        <Modal
            title={messages['driverStatusLogDelete_title']}
            open={open}
            loading={loading}
            position="right"
            size="medium"
            handleClose={handleClose}
            footer={(
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                    <Button
                        disabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        disabled={loading || !driverStatusLogs?.length}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            setErrorMessage("");
                            if (driverStatusLogs?.length) {
                                dispatch(deleteDriverStatusLogs({
                                    ids: driverStatusLogs?.map(df => parseInt(df?.id))
                                }));
                            }
                        }}
                        variant='warning'
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: 24 }}>
                <Typography
                    variant="subtitle2"
                    color="textSecondary"
                >
                    {messages['driverStatusLogDelete_deleteWarning']}
                </Typography>

                {
                    driverStatusLogs?.length > 0 &&
                    <ul>
                        {
                            driverStatusLogs?.map((driverStatusLog, key) => {
                                return (
                                    <li key={driverStatusLog?.id || `${driverStatusLog?.driverStatus?.id}-${key}` || key}>
                                        <span>
                                            {DEFAULT_DRIVER_STATUS_ACTIONS[driverStatusLog?.driverStatus?.id] ? messages[defaultDriverStatusActions[driverStatusLog?.driverStatus?.id]] : driverStatusLog?.driverStatus?.name}
                                        </span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                }

                {errorMessage &&
                    <Alert severity="error" onClose={() => setErrorMessage("")}>{errorMessage}</Alert>
                }

            </div>
        </Modal>
    );
}

export default DeleteDriverStatusLog;